export enum MethodOptions {
  InPerson = 1,
  OnThePhone = 2,
  ChartReview = 3,
  SecureLink = 4,
}
